import { useMemo } from "react";
import moment from "moment";

const useProductData = (fetchData) => {
  const data = fetchData;
  // console.log("checking data in product", fetchData);

  const formattedData = useMemo(() => {
    const rows = [];

    if (data && Array.isArray(data)) {
      data.forEach((product, index) => {
        if (product.Orders && product.Orders.length > 0) {
          const order = product.Orders[0];
          const customer = order.Customer;

          const row = {
            id: index,
            picture: product.Pictures.map((picture) => ({
              id: picture.id,
              picture: picture.pic
                .split("http")
                .filter(Boolean)
                .map((url) => `http${url.trim()}`),
            })),
            product_id: product.product_id,
            product_code: product.product_code,
            product_name: product.product_name,
            category: product.category_id,
            detail: product.detail,
            blemishes: product.blemishes,
            size: product.size,
            price: product.price,
            total_price: product.total_price,
            total_amount: product.total_amount,
            created_date: moment(customer.created_date).format(
              "DD/MM/YYYY\n เวลา HH:mm:ss น."
            ),
            updated_date: moment(customer.updated_date).format(
              "DD/MM/YYYY\n เวลา HH:mm:ss น."
            ),
            customer_id: customer.id,
            customer_name: customer.name,
            idcard: customer.idcard,
            customer_image: customer.image,
            customer_address: customer.address,
            customer_phonenumber: customer.phonenumber,
          };

          rows.push(row);
        }
      });
    }

    return rows;
  }, [data]);

  return formattedData;
};

export default useProductData;
